var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Zpět_ikona","data-name":"Zpět ikona","transform":"translate(-7 -9.5)"},[React.createElement("path",{"id":"Path_194","data-name":"Path 194","d":"M22.5,18H7.5","transform":"translate(0 -5)","fill":"none","stroke":"#00C6CC","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1","key":0}),React.createElement("path",{"id":"Union_1","data-name":"Union 1","d":"M-206.5-3624l3-3-3,3,3,3Z","transform":"translate(214 3637)","fill":"none","stroke":"#00C6CC","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1","key":1})]));
}

Arrow.defaultProps = {"width":"16","height":"7","viewBox":"0 0 16 7"};

module.exports = Arrow;

Arrow.default = Arrow;
